import React, { FC } from 'react';

export const LayoutTwoThirds: FC = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 15L15 15C15.55 15 16 14.55 16 14L16 5C16 4.45 15.55 4 15 4L4 4C3.45 4 3 4.45 3 5L3 14C3 14.55 3.45 15 4 15ZM15 5L15 14L12 14L12 5L15 5ZM4 5L11 5L11 14L4 14L4 5Z"
      fill="currentColor"
    />
  </svg>
);
